import Handlebars from 'handlebars';
import Map from 'map';

export default class List {
  build(listData, options) {
    this.buildTemplate(listData, options);
    this.pagination(
      listData.page,
      listData.total_pages,
      "#pagination",
      options
    );
  }

  buildTemplate(data, options) {
    var source = $(options.template_id).html();
    var template = Handlebars.compile(source);
    var data = {
                objects: data["records"],
                statistic_1: data.statistic_1,
                statistic_1_label: data.statistic_1_label,
                statistic_2: data.statistic_2,
                statistic_2_label: data.statistic_2_label,
                statistic_3: data.statistic_3,
                statistic_3_label: data.statistic_3_label,
                display_pagination: data.display_pagination,
                results_empty: data.results_empty
               };
    var html = template(data);
    $(options.target_id).html(html);
    // new SimpleBar(document.getElementById('record-list'));

    $('.js-record-card').on("click", (element) => {
      $('.js-record-card').removeClass('active');
      $(element.target).closest('.js-record-card').addClass('active');
      let recordId = $(element.target).closest('.js-record-card').data().recordId;
      Map.openPopup(recordId);
    })
    if(data.display_pagination) {
      $('.js-pagination-container').show()
    } else {
      $('.js-pagination-container').hide()
    }

    if (document.getElementById('js-display-type').dataset.displayType == 'actor') {
      $(".js-standard-record-indicator").hide()
      $(".js-actor-record-indicator").show()
    } else {
      $(".js-standard-record-indicator").show()
      $(".js-actor-record-indicator").hide()
    }
  };

  pagination(current_page, total_pages, pagination_id, options) {
    var pagination_options = {
      currentPage: current_page,
      totalPages: total_pages,
      bootstrapMajorVersion: 3,
      numberOfPages: 3,
      onPageClicked: function(e, originalEvent, type, page_clicked){
        window.buildList(page_clicked)
      },
      itemTexts: function (type, page, current) {
        switch (type) {
        case "first":
            return "First";
        case "prev":
            return "<";
        case "next":
            return ">";
        case "last":
            return "Last";
        case "page":
            return page;
        }
      }
    };
    $(pagination_id).bootstrapPaginator(pagination_options);
  };
};




